import React from 'react';
import PropTypes from 'prop-types';
import { formatDistance } from '../../../../../_shared/helpers/formatting';
import { Header, TextWrapContainer } from '../Styles';

const propTypes = {
  testId: PropTypes.string.isRequired,
  mileage: PropTypes.number.isRequired,
  odometerType: PropTypes.string.isRequired,
  transmission: PropTypes.string.isRequired,
  trim: PropTypes.string.isRequired
};

const TradeHeader = ({ testId, mileage, odometerType, transmission, trim }) => {
  const formatString = () => {
    const trimStr = trim ? ` | ${trim}` : '';
    const distance = formatDistance(mileage);
    return `${distance} ${odometerType || '-'} | ${transmission}${trimStr}`;
  };

  return (
    <Header testId={`${testId}-header`}>
      <TextWrapContainer data-testid={`${testId}-wrap`}>
        {formatString()}
      </TextWrapContainer>
    </Header>
  );
};

TradeHeader.propTypes = propTypes;

export default TradeHeader;
